import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import QrCodes from './pages/QrCodes';
import Schemes from './pages/Schemes';
import Users from './pages/Users';
import Orders from './pages/Orders';
import Config from './pages/Config';
import PreRegisteredUsers from './pages/PreRegisteredUsers';
import PendingUsers from './pages/PendingUsers';
import LabourerPage from './pages/LabourerPage';
import RedeemableProducts from './pages/RedeemableProducts';
import LabourPayouts from './pages/LabourPayouts';
import QrLabelPrintPage from './pages/QrLabelPrintPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Labourer public page */}
          <Route path="/" element={<LabourerPage />} />

          {/* Admin routes */}
          <Route path="/console/login" element={<LoginPage />} />
          <Route path="/console" element={<AdminLayout />}>
            <Route index element={<Navigate to="/console/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="qr-codes" element={<QrCodes />} />
            <Route path="qr-codes/:batchNumber/labels" element={<QrLabelPrintPage />} />
            <Route path="schemes" element={<Schemes />} />
            <Route path="redeemable-products" element={<RedeemableProducts />} />
            <Route path="users" element={<Users />} />
            <Route path="pre-registered" element={<PreRegisteredUsers />} />
            <Route path="pending-users" element={<PendingUsers />} />
            <Route path="orders" element={<Orders />} />
            <Route path="labour-payouts" element={<LabourPayouts />} />
            <Route path="config" element={<Config />} />
          </Route>
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </AuthProvider>
  );
}

export default App;
